export default {
  address: '新北市三重區水漾路二段(二重公園旁)',
  googleSrc:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.0441821896475!2d121.4743896!3d25.066491600000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a9e54737b417%3A0x7f67982594057b6!2z6JCK6Iy15rC06Iqx5ZySIOaOpeW-heS4reW_gw!5e0!3m2!1szh-TW!2stw!4v1683248411852!5m2!1szh-TW!2stw',
  googleLink: 'https://goo.gl/maps/Cb6ZoQdqrv9WLbaq8',
  phone: '02-2988-8989',
  fbLink: 'https://www.facebook.com/100090972819708',
  fbMessage: 'https://m.me/106355995725337',
  caseName: '萊茵水花園',
  indigatorLength: 10, 

  houseInfos: [
    ['預約專線', '02-2988-8989'],
    ['接待會館', '新北市三重區水漾路二段（二重公園旁)'],
    ['投資興建', '漢翔開發股份有限公司'],
    ['建築規劃', '陳麗珍．高仲廷建築師事務所'],
    ['景觀規劃', '大漢設計工程有限公司'],
    ['公設設計', '珩荷空間設計有限公司'],
    ['建築代銷', '聯碩地產股份有限公司'],
    ['建照號碼', '111建字第00394號'],
    ['經紀人', '陳慧育（112）新北經字第004044號']
  ],

  gtmCode: ['WQSSD86'], // 可放置多個
  recaptcha_site_key_v2: '6Lep-78UAAAAAMaZLtddpvpixEb8cqu7v7758gLz',
  recaptcha_site_key: '6Lck-L8UAAAAABxfvNA1NJuBrdl3iLFc3GkudC8s', // recaptcha v3
  recaptcha_user_token: '6Lck-L8UAAAAAIcvenwGDl8_Q1tKbrEYsKuriePa',
  order: {
    title: 'CONTACT US',
    subTitle: ''
  }
}
